module.exports = __webpack_public_path__ + "static/media/1629907160864.a1edee25.png";